const state = {
    paymentForm: null,
    giftcardMultipleRequest: false,
    giftcardSession: []
}

export default state;